export default __webpack_public_path__ + "static/media/logo-light.fe90178c.png";